import React from 'react'
import { Form, Col } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'

function CustomInput({ label, md, errorPath, validation, options, ...props }) {
  const { register, getValues } = useFormContext()
  return (
    <Col md={md}>
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          {...props}
          ref={register(validation)}
          isValid={
            !errorPath && options
              ? getValues(props.name) !== '-1'
              : getValues(props.name)
          }
          isInvalid={!!errorPath}
        >
          {options &&
            [{ id: -1, descripcion: 'Seleccione una opción' }, ...options].map(
              (opt) => (
                <option key={opt.id} value={opt.id}>
                  {opt.descripcion}
                </option>
              )
            )}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          {errorPath?.message}
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  )
}

export default CustomInput
